import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import CalculatorIcon from "../../../Assets/SVG/CalculatorIcon";
import useQueryParams from "../../../Hooks/UseQueryParams";
import React from "react";
import {useShopifyOrderIntegrations} from "../../../Apis/ShopifyOrderIntegrationApi";
import ShopifyOrderIntegrationsList from "../../../Features/Settlements/ShopifyOrderIntegrationsList";
import {useNavigate} from "react-router-dom";
import Button from "../../../Components/Button";

const Index = () => {

    const { t } = useTranslation();

    const [ filter ] = useQueryParams({});

    const { data: shopifyOrderIntegrations, isLoading } = useShopifyOrderIntegrations(filter);

    const navigate = useNavigate();

    return (
        <PageLayout title={t('shopifyOrderIntegrations')} icon={<CalculatorIcon />} header={(
            <>
                <Button prefix={<CalculatorIcon fill={"#FFF"} />} text={t('addShopifyOrderIntegration')} type={"primary"} onClick={() => navigate("new")} />
            </>
        )}>
            <>
                <ShopifyOrderIntegrationsList data={shopifyOrderIntegrations?.items} isLoading={isLoading} />
            </>
        </PageLayout>
    )
}

export default Index
